module.exports = __webpack_public_path__ + "static/media/wiki_media.0829f5a8.png";